import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted" }, "ID:", -1)
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted" }, "Tiêu đề kế hoạch:", -1)
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted" }, "Ngày tạo:", -1)
const _hoisted_6 = { class: "fw-bold" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted" }, "Cấp SC:", -1)
const _hoisted_8 = { class: "fw-bold" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted" }, "Danh mục toa xe:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted" }, "Số lượng toa:", -1)
const _hoisted_11 = { class: "fw-bold" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted" }, "Tháng:", -1)
const _hoisted_13 = { class: "fw-bold" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted" }, "Ghi chú:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmHoanThanh = _resolveComponent("ConfirmHoanThanh")!
  const _component_button_custom = _resolveComponent("button-custom")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_DivCol = _resolveComponent("DivCol")!
  const _component_DivRow = _resolveComponent("DivRow")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_PageRowLayout = _resolveComponent("PageRowLayout")!
  const _component_dinh_muc_co_dinh_section = _resolveComponent("dinh-muc-co-dinh-section")!
  const _component_PerPageSelection = _resolveComponent("PerPageSelection")!
  const _component_BienBanGiaiTheTable = _resolveComponent("BienBanGiaiTheTable")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmHoanThanh, {
      "bien-ban-data": _ctx.selectingBienBan,
      show: _ctx.confirmHoanThanhBienBan,
      onConfirm: _ctx.hoanThanhHander,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmHoanThanhBienBan = false))
    }, null, 8, ["bien-ban-data", "show", "onConfirm"]),
    _createVNode(_component_PageRowLayout, null, {
      "page-row-header": _withCtx(() => [
        _createTextVNode(" Chi tiết ")
      ]),
      "page-row-action-button": _withCtx(() => [
        _createVNode(_component_button_custom, {
          "button-type": _ctx.ButtonsType.EDIT,
          "color-type": _ctx.ButtonTypeColors.SUCCESS,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.push(`/quan-ly/ke-hoach-sua-chua/chinh-sua/${_ctx.idKeHoach}`)))
        }, null, 8, ["button-type", "color-type"]),
        _createVNode(_component_ButtonCustom, {
          "button-type": _ctx.ButtonsType.FA_WRENCH,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.push(`/quan-ly/ke-hoach-sua-chua/${_ctx.idKeHoach}/bien-ban-giai-the/tao-moi`)))
        }, {
          "button-label": _withCtx(() => [
            _createTextVNode("Tạo BBGT")
          ]),
          _: 1
        }, 8, ["button-type"]),
        _createVNode(_component_ButtonCustom, {
          "button-type": _ctx.ButtonsType.BACK,
          onClick: _ctx.goBack
        }, null, 8, ["button-type", "onClick"])
      ]),
      "page-row-content": _withCtx(() => [
        _createVNode(_component_DivRow, null, {
          default: _withCtx(() => [
            _createVNode(_component_DivCol, null, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_DivCol, null, {
              default: _withCtx(() => [
                _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.keHoachDetail?.id), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_DivCol),
            _createVNode(_component_DivCol, { cols: 2 }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_DivCol, { cols: 3 }, {
              default: _withCtx(() => [
                _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.keHoachDetail?.ten_ke_hoach), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_DivCol, null, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            (_ctx.keHoachDetail)
              ? (_openBlock(), _createBlock(_component_DivCol, {
                  key: 0,
                  cols: 2
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.moment(_ctx.keHoachDetail.created_at).format('DD/MM/YYYY')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_DivRow, { class: "mt-5" }, {
          default: _withCtx(() => [
            _createVNode(_component_DivCol, null, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_DivCol, { cols: 2 }, {
              default: _withCtx(() => [
                _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.keHoachDetail?.cap_sua_chua.ten_cap_sc), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_DivCol, { cols: 2 }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_DivCol, { cols: 3 }, {
              default: _withCtx(() => [
                (_ctx.keHoachDetail)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: {
              name: 'chi-tiet-danh-muc-toa-xe',
              params: { id: _ctx.keHoachDetail.danh_muc_toa_xe.id } }
            
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.keHoachDetail?.danh_muc_toa_xe.ten_danh_muc), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_DivCol, { cols: 1 }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_DivCol, { cols: 3 }, {
              default: _withCtx(() => [
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.keHoachDetail?.so_luong_toa_xe) + " toa", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DivRow, { class: "mt-5" }, {
          default: _withCtx(() => [
            _createVNode(_component_DivCol, { cols: 1 }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }),
            _createVNode(_component_DivCol, { cols: 3 }, {
              default: _withCtx(() => [
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.keHoachDetail?.thang), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DivRow, { class: "mt-5" }, {
          default: _withCtx(() => [
            _createVNode(_component_DivCol, null, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }),
            (_ctx.keHoachDetail)
              ? (_openBlock(), _createBlock(_component_DivCol, {
                  key: 0,
                  cols: 4
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.keHoachDetail.ghi_chu,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.keHoachDetail.ghi_chu) = $event)),
                      rows: 3,
                      type: "textarea",
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.keHoachDetail)
      ? (_openBlock(), _createBlock(_component_dinh_muc_co_dinh_section, {
          key: 0,
          "create-phieu-xuat-show": false,
          idCapSuaChua: _ctx.keHoachDetail.id_cap_sc,
          idDanhMucToaXe: _ctx.keHoachDetail.id_danh_muc_toa_xe
        }, null, 8, ["idCapSuaChua", "idDanhMucToaXe"]))
      : _createCommentVNode("", true),
    _createVNode(_component_PageRowLayout, null, {
      "page-row-header": _withCtx(() => [
        _createTextVNode(" Biên bản giải thể ")
      ]),
      "page-row-action-button": _withCtx(() => [
        _createVNode(_component_ButtonCustom, {
          "button-type": _ctx.ButtonsType.FA_WRENCH,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.push(`/quan-ly/ke-hoach-sua-chua/${_ctx.idKeHoach}/bien-ban-giai-the/tao-moi`)))
        }, {
          "button-label": _withCtx(() => [
            _createTextVNode("Tạo BBGT")
          ]),
          _: 1
        }, 8, ["button-type"])
      ]),
      "page-row-content": _withCtx(() => [
        _createVNode(_component_PerPageSelection, {
          "per-page": _ctx.perPage,
          "per-page-arr": _ctx.perPageArr,
          onChange: _cache[5] || (_cache[5] = (value) => _ctx.perPage = value)
        }, null, 8, ["per-page", "per-page-arr"]),
        _createVNode(_component_BienBanGiaiTheTable, {
          "is-ke-hoach-column-displaying": false,
          items: _ctx.bienBanItems,
          onOnDetailClick: _cache[6] || (_cache[6] = ({ id }) => _ctx.push(`/quan-ly/bien-ban-giai-the/chi-tiet/${id}`)),
          onOnEditClick: _cache[7] || (_cache[7] = ({ id }) => _ctx.push(`/quan-ly/bien-ban-giai-the/cap-nhat/${id}`)),
          onOnCheckClick: _ctx.selectBienBanHandler
        }, null, 8, ["items", "onOnCheckClick"]),
        (_ctx.bienBanItems.length > 0)
          ? (_openBlock(), _createBlock(_component_Pagination, {
              key: 0,
              page: _ctx.currentPage,
              "page-size": _ctx.perPage,
              total: _ctx.totalItems,
              onChangePage: _cache[8] || (_cache[8] = (value) => _ctx.currentPage = value)
            }, null, 8, ["page", "page-size", "total"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}